<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19.8049 2.5H5.19506C3.70665 2.5 2.5 3.7066 2.5 5.19506V19.805C2.5 21.2934 3.7066 22.5001 5.19506 22.5001H12.4006L12.4128 15.3531H10.5561C10.3148 15.3531 10.1189 15.158 10.118 14.9167L10.1091 12.6129C10.1082 12.3703 10.3046 12.1732 10.5472 12.1732H12.4006V9.94714C12.4006 7.36388 13.9783 5.95727 16.2827 5.95727H18.1737C18.4156 5.95727 18.6118 6.15341 18.6118 6.3954V8.33793C18.6118 8.57982 18.4158 8.77591 18.174 8.77606L17.0135 8.7766C15.7603 8.7766 15.5176 9.37212 15.5176 10.2461V12.1732H18.2714C18.5338 12.1732 18.7373 12.4023 18.7064 12.6629L18.4334 14.9666C18.4072 15.1871 18.2203 15.3532 17.9983 15.3532H15.5299L15.5176 22.5001H19.805C21.2934 22.5001 22.5 21.2935 22.5 19.8051V5.19506C22.5 3.7066 21.2933 2.5 19.8049 2.5Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgFacebook',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>